import axios from "axios";
export const lienImage = "https://go2babi.lce-ci.com/public/public/image/";
export const lienMedia = "https://go2babi.lce-ci.com/public/public/fichier/";
const instance = axios.create({
  baseURL: "https://go2babi.lce-ci.com/api",
});

instance.interceptors.request.use((config) => {
  const token = JSON.parse(localStorage.getItem("token"));
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default instance;
